<template>
  <div>
    <div class="card card-custom" style="margin-bottom: 10px;">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">{{ $t(head_title) || 'N/A' }}</h3>
        </div>
        <div class="card-toolbar">
          <div v-on:click="dataTakenAdd()"
               class="btn btn-primary"
          >
            <i class="flaticon2-add"></i>
          </div>
        </div>
      </div>
      <div v-if="api_data && api_data.Farmer">
        <div v-for="(data_in_json_each, indexMain) in api_data.Farmer[data_in_json_input]"
             :key="indexMain"
             class="card-body">
          <div class="row">
            <div class="col-md-11">
              <div class="row">
                <div class="col-md-6" v-for="(form_fields_each,index) in form_fields"
                     :key="index"
                >

                  <div v-if="form_fields_each.type == 'textarea'">
                    <label>{{ $t(form_fields_each.label) }}</label>
                    <textarea class="form-control form-control-solid"
                              :placeholder="form_fields_each.label"
                              v-model="data_in_json_each[form_fields_each.name]"
                    ></textarea>
                  </div>
                  <div v-if="form_fields_each.type != 'textarea'">
                    <label>{{ $t(form_fields_each.label) }}</label>
                    <input class="form-control form-control-solid"
                           v-model="data_in_json_each[form_fields_each.name]"
                           :placeholder="form_fields_each.label"
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1">
              <div class="form-group">
                <label>Action</label>
                <div v-on:click="dataTakenDelete(indexMain)"
                     class="form-control btn btn-danger"
                >
                  <i class="flaticon2-delete"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'store-short-data-from-json',
  props: {
    api_data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    data_in_json_input: {
      type: String,
      default: function () {
        return '';
      },
    },
    head_title: String,
  },
  methods: {
    dataTakenDelete(index) {
      this.$props.api_data.Farmer[this.$props.data_in_json_input].splice(index, 1);
    },
    dataTakenAdd(option = null) {
      if (!option) {
        option = {
          title: '',
          note: '',
        };
      }
      this.$props.api_data.Farmer[this.$props.data_in_json_input] = this.$props.api_data.Farmer[this.$props.data_in_json_input] || [];
      this.$props.api_data.Farmer[this.$props.data_in_json_input].push(option);
    }
  },
  data: () => ({
    form_fields: {
      'title': {
        'name': 'title',
        'label': 'Title',
      },
      'note': {
        'name': 'note',
        'type': 'textarea',
        'label': 'Note',
      }
    },
  }),
}
</script>
